var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"comsobase-course__title container"},[_vm._v(" Програма курсу ")])
}
var staticRenderFns = []

export { render, staticRenderFns }